import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery, UseQueryOptions } from '@tanstack/react-query'

type UseMaintenanceObjectivePartsProps<T> = {
  filters?: {
    search?: string
    objectiveSystem?: string
    equipmentId?: string
    page?: number
  }
  options?: Partial<UseQueryOptions<any>>
  mapper?: (data: any) => T
}

export const useMaintenanceObjectiveParts = <T,>({
  filters: { search, objectiveSystem, equipmentId, page } = {},
  options = {},
  mapper = Mapper.default<T>(),
}: UseMaintenanceObjectivePartsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['maintenanceObjectiveParts', search, objectiveSystem, equipmentId, page],
    queryFn: () => {
      return privateAxios.get(`/maintenance/objective_systems/${objectiveSystem}/parts`, {
        params: {
          search: search || undefined,
          'q[equipment_id_eq]': equipmentId || undefined,
          page,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
    ...options,
  })

  return { data, meta, ...rest }
}
